import { Type } from 'class-transformer';
import { FrontendFieldDefinition } from './frontend-field-definition.model';

export class GenericObjectDefinition {

    scope = "";
    id = "";
    title = "";
    icon = "";
    nameSingular = "";
    namePlural = "";
    singleton = false;
    apiEndpoint = "";
    @Type(() => FrontendFieldDefinition)
    attributes: FrontendFieldDefinition[] = [];

}